import React from 'react';
import { Link } from '@sls-react/routing';
import { AnchorProps } from '@sls-react/components/Links/A';

const SellNowLink: React.FC<AnchorProps> = ({ children, ...props }) => (
  <Link href="/sell-now" passHref>
    <a {...props}>{children}</a>
  </Link>
);

export default SellNowLink;
